import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';
import {CURSOR,DISPLAY} from '../../../../../styles/fonts/MCFontConstants';
export const TemplateContainer = styled.div`
    ${scrollBarStyle}
    padding-right: 8px;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 200px);
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 4px;
    padding-bottom: ${({ paddingBottom }) =>
        paddingBottom ? paddingBottom : '0px'};
    padding-left: 3px;

    //ipad Pro(10.5 inch) landscape
    @media only screen and (min-device-width: 1112px) and (max-device-width: 1112px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        padding-bottom: ${({ isTemplate }) => isTemplate && '10rem'};
    }

    //ipad pro(10.5 inch) portrait
    @media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) {
        padding-bottom: ${({ isTemplate }) => isTemplate && '10rem'};
    }

    ${media.mobileDevice`
    height: 100%;
    overflow-y: unset;
    &::-webkit-scrollbar {
        display: none;
    }
    padding-right: 4px;
    margin: ${({ mbBannerMargin }) => mbBannerMargin};
    padding-bottom: 200px;
    `}
`;
export const TemplateDetailWrapper = styled.div`
    ${media.mediumDevice`
        padding: 15px;
    `};
    ${media.smalDevice`
        padding: 15px;
    `};
    ${media.mobileDevice`
        padding: 0;
    `}
`;

export const FooterContainer = styled.div`
    position: absolute;
    bottom: 0;
    right: -16px;
    left: -16px;
    ${media.mediumDevice`
       margin-top: 17px;
       position: fixed;
    `};

    /* ${media.smalDevice`
    position: fixed;
    `}; */

    /* @media screen and (min-width: 830px) and (max-width: 840px) and (orientation: portrait) {
        position: fixed;
    }

    //ipad pro(10.5 inch) portrait
    @media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) {
        position: fixed;
    } */

    //ipad Air portrait
    @media only screen and (min-device-width: 820px) and (max-device-width: 820px) and (orientation: portrait) {
        position: fixed;
    }

    @media screen and (min-width: 800px) and (max-width: 820px) and (orientation: portrait) {
        position: fixed;
    }

    /* @media screen and (min-width: 768px) and (max-width: 780px) and (orientation: portrait) {
        position: fixed;
    } */

    ${media.mobileDevice`
       margin-top: 0px;
    `}
`;

export const TemplateMainContainerBox = styled.div`
    ${media.mediumDevice`
        padding: 15px;
    `};
    ${media.smalDevice`
    padding: 15px;
    `};
`;
export const TemplateTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: ${({ deskMargin }) =>
        deskMargin ? deskMargin : '4px 10px 4px 8px'};
    justify-content: space-between;
    align-items: center;
    ${media.mobileDevice`
          margin: 21px 16px 0px 21px;
    `}
`;

export const TemplateTitle = styled.div`
    letter-spacing: 0px;
    color: #130e4a;
    opacity: 1;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 18px;
`;

export const Icon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 21.03px;
    height: 20px;
    display: ${({ show }) => (show ? DISPLAY : NONE)};
    cursor: ${(props) => (props.hideCursor ? UNSET : CURSOR)};
    ${media.mobileDevice`
    display: ${DISPLAY};
    `}
`;
export const NotesContainer = styled.div`
    margin: 'auto';
    width: '90%';
    height: 140px;
    margin-top: 10px;
    margin-bottom: 10px;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
`;

export const TemplateNotesParentDiv = styled.div`
    border-radius: ${({ isFromTemplates }) => isFromTemplates && '6px'};
    box-shadow: ${({ isFromTemplates }) =>
        isFromTemplates && '0px 0px 6px #00000029'};
    margin: ${({ isFromTemplates }) => isFromTemplates && '12px 0px 0px 0px'};
    padding: ${({ isFromTemplates }) => isFromTemplates && '0 0px 25px 10px'};
    background: ${({ isFromTemplates }) =>
        isFromTemplates && '#ffffff 0% 0% no-repeat padding-box'};
`;

export const Title = styled.div`
    letter-spacing: 0px;
    color: #140f4b;
    text-transform: uppercase;
    opacity: 1;
    font-size: 18px;
    text-align: left;
    margin: 6px 15px 0px 4px;
    font-family: 'AvenirNextWorld Demi';
    order: 1;
    width: 60%;
    word-break: break-all;
    ${media.mobileDevice`
        width: ${({ width }) => (width ? width : '80%')};
        order: 1;
        margin: 13px 15px 0px 0px;
    `}
`;

export const SubContainerRows = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    ${media.mobileDevice`
        flex-direction: column;
        margin-right:  ${({ addMarginToAlign }) =>
            addMarginToAlign ? '12px' : '17px'};
        margin-left: ${({ addMarginToAlign }) =>
            addMarginToAlign ? '18px' : '21px'};
    `}
`;
export const LabelsContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0 10px 5px 0;
    align-items: center;
    justify-content: flex-start;
    order: 3;
    & .chipName {
        font-size: 12px;
        font-family: 'AvenirNextWorld Regular';
        padding: 0px !important;
    }
    .MuiChip-label {
        font-size: 12px;
        font-family: 'AvenirNextWorld Regular';
    }
    .MuiChip-root {
        padding: 0px !important;
    }
    ${media.mobileDevice`
    order: 1;
    margin:${({ addNegativeMargin }) =>
        addNegativeMargin ? '13px 5px 14px -6px' : '13px 5px 14px 0px'};
`}
`;
export const LabelItem = styled.div`
    background: #e8e8e8 0% 0% no-repeat padding-box;
    border-radius: 17px;
    opacity: 1;
    letter-spacing: -0.1px;
    color: #313131;
    opacity: 1;
    font-family: 'AvenirNextWorld Regular';
    margin-right: 16px;
    padding: 1px 6px;
    font-size: 14px;
`;

export const UserAndFavoritesContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 11px 2px 11px 4px;
    align-items: center;
    justify-content: flex-start;
    order: 2;
    ${media.mobileDevice`
    margin: 11px 2px 0px 4px;
`}
`;

export const FavouriteIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 26px;
    height: 26px;
    display: block;
    cursor: pointer;
`;

export const UserIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 19px;
    height: 19px;
    display: block;
    ${media.mobileDevice`
    margin-top:-1px;
`}
`;

export const UserNameAndDateContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    margin-left: 23.5px;
    ${media.mobileDevice`
       margin-right: auto;
       margin-left: 10px;
    `};
    & .userName {
        letter-spacing: 0;
        text-align: left;
        font-family: 'AvenirNextWorld Demi';
        letter-spacing: 0px;
        color: #140f4b;
        opacity: 1;
        font-size: 14px;
    }

    & .dateStamp {
        text-align: left;
        font-family: 'AvenirNextWorld Regular';
        letter-spacing: -0.1px;
        color: #000000;
        opacity: 0.6;
        font-size: 12px;
        margin-top: -5px;
    }
`;
export const FavoriteIconContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
    ${media.mobileDevice`
         margin-left:21px;
         order:2
    `};
`;

export const MoreInfoContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    flex-direction: column;
`;
export const CommonItemsMainContainer = styled.div`
    margin: ${({ margin }) => (margin ? margin : '0px')};
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    ${media.mobileDevice`
       flex-direction: column;
       margin: ${({ mobileMargin }) => (mobileMargin ? mobileMargin : '0px')};
    `};
`;
export const CommonItemsContainer = styled.div`
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '20px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    display: flex;
    flex-direction: column;
    flex-basis: ${({ flexbasis }) => (flexbasis ? flexbasis : '48%')};
    align-items: ${({ alignItemsCenter }) =>
        alignItemsCenter ? 'center' : ''};

    ${media.mobileDevice`
        flex-basis: 0;
        display: block;
        margin-top: ${({ mbMarginTop }) =>
            mbMarginTop ? mbMarginTop : '20px'};
    `};
`;

export const AccountPhysicianProceduContainer = styled(MoreInfoContainer)`
    //margin: 2px;
    padding: 10.67px 10px 20px 20px;
    flex-wrap: wrap;
    display: block;
    margin-bottom: ${({ marginbottom }) =>
        marginbottom ? marginbottom : '12px'};
    ${media.mobileDevice`
        margin: ${({ mbMargin }) =>
        mbMargin ? mbMargin : '10px 14px 0px'};
          padding: 0px 10px 10px 20px;
        `};
`;
export const MainSegmentSection = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 12px 0 0 0;
    padding: 0 2px 0 3px;
    ${media.mobileDevice`
    flex-direction:column;
    justify-content: space-between;
    padding: 11px 0px 0px;
    background: #f5f5f7;
    border-top : 2px solid #ebebeb;
    `}
`;

export const SetsAndItemsContainer = styled(MoreInfoContainer)`
    margin-top: 2px;
    margin-bottom: 8px;
`;

export const MoreInfoItemTitle = styled.div`
    letter-spacing: 0px;
    text-align: left;
    color: #202124;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    //margin: 0px 0px 0px 20px;
`;

export const MoreInfoItemValue = styled(MoreInfoItemTitle)`
    font-family: 'AvenirNextWorld Regular';
    //territory displayed in two lines resolved
    font-size: 15px;
    word-break: break-word;
    //margin-bottom: 18px;
`;
export const DeleteIconView = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-right: 15px;
`;
export const AccPhysProceTitle = styled(MoreInfoItemTitle)`
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    font-size: ${({ mobileHeader }) => (mobileHeader ? '16px' : '16px')};
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
      margin-top:${({ mobileHeader }) => (mobileHeader ? '10px' : '')};
      margin-left:${({ mobileHeader }) => (mobileHeader ? '22px' : '')};
      
`};
`;
export const AccPhysProceValue = styled(MoreInfoItemTitle)`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    // scroll working after adding add selected to cart button
    padding-bottom: ${({ addExtraPadding }) =>
        addExtraPadding ? '10px' : '3px'};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    overflow-wrap: break-word;
    margin-right: 20px;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
`;
export const NoOptionalContainer = styled.div`
    padding-left: 15px;
`;
export const ChipContainer = styled.div`
    display: flex;
    flex-direction: row;
`;
export const CustomizeRowView = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 95%;
    margin: 20px auto 5px;
`;

export const AutoCompleteDiv = styled.div`
    width: 90%;
    margin-left: 10px;
    margin: 10px 0px 5px 20px;
`;
export const AutoCompleteContainer = {
    margin: 'auto',
    width: '90%',
    marginTop: '10px',
};

export const LoadingTextStyles = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 16px;
    letter-spacing: 0px;
    color: ${({ color }) => (color ? '#4F4F4F' : '#ffffff')};
`;

export const SpinningLoaderContainer = styled.div`
    height: 100%;
    width: 100%;
    margin-top: ${({ deskMarginTop }) =>
        deskMarginTop ? deskMarginTop : '0px'};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    ${media.mobileDevice`
        margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
        height:${({ mbHeight }) => mbHeight};
    `}
`;
